import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  Form,
} from "reactstrap";
import { ArchivoExamenService } from "service/ArchivoExamenService";
import FSelect from "components/Select/FSelect";

const archivoService = new ArchivoExamenService();

const ModalArchivoExamen = ({ isOpen, toggle, selectedArchivo, onSave }) => {
  const [archivo, setArchivo] = useState({
    descripcion: "",
    urldrive: "",
    estado: "Activo",
  });

  useEffect(() => {
    if (isOpen) {
      setArchivo(selectedArchivo ?? { descripcion: "", urldrive: "", estado: "Activo" });
    }
  }, [isOpen, selectedArchivo]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setArchivo((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    if (!archivo.descripcion.trim()) {
      alert("La descripción es obligatoria");
      return;
    }
    try {
      const res = archivo._id
        ? await archivoService.updateArchivo(archivo)
        : await archivoService.addArchivo(archivo);
      if (res?.confirmation === "success") {
        alert(archivo._id ? "Archivo actualizado" : "Archivo registrado");
        onSave();
        toggle();
      } else {
        alert(res?.message || "Error al procesar");
      }
    } catch (error) {
      console.error("Error guardando archivo:", error);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="md" backdrop="static">
      <ModalHeader toggle={toggle}>
        {archivo._id ? "Editar Archivo" : "Agregar PDF de Examen"}
      </ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label>Descripción</Label>
            <Input
              name="descripcion"
              value={archivo.descripcion}
              onChange={handleChange}
              placeholder="Descripción del archivo de examen"
            />
          </FormGroup>
          <FormGroup>
            <Label>URL de Google Drive</Label>
            <Input
              name="urldrive"
              value={archivo.urldrive}
              onChange={handleChange}
              placeholder="https://drive.google.com/..."
            />
          </FormGroup>
          <FormGroup>
            <Label>Estado</Label>
            <FSelect
              name="estado"
              value={archivo.estado}
              onChange={handleChange}
              options={[
                { value: "Activo", label: "Activo" },
                { value: "Inactivo", label: "Inactivo" },
              ]}
            />
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>Cancelar</Button>
        <Button color="primary" onClick={handleSave}>Guardar</Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalArchivoExamen;
